import { render, staticRenderFns } from "./AccountTypesExampleStep.vue?vue&type=template&id=bb77a966"
import script from "./AccountTypesExampleStep.vue?vue&type=script&lang=js"
export * from "./AccountTypesExampleStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports